import { useRef, useState, useEffect } from "react";
import { POLICY_CHECK_MAX_COUNT, POLICY_CHECK_INTERVAL } from "constants/policy";
import { getPolicyProgressCount } from "helpers";

const useCheckPolicyProgress = (policy) => {
  const { processed, uploadedAt, createdAt } = policy;
  const countRef = useRef(processed ? POLICY_CHECK_MAX_COUNT : getPolicyProgressCount(uploadedAt || createdAt));
  const [, forceUpdate] = useState(0);

  useEffect(() => {
    if (!processed && countRef.current < POLICY_CHECK_MAX_COUNT) {
      const interval = setInterval(() => {
        if (countRef.current >= POLICY_CHECK_MAX_COUNT) {
          clearInterval(interval);
        } else {
          countRef.current = countRef.current + 1;
          forceUpdate(countRef.current);
        }
      }, POLICY_CHECK_INTERVAL);

      return () => clearInterval(interval);
    }
  }, []);

  const progress = (POLICY_CHECK_INTERVAL * countRef.current) / (POLICY_CHECK_MAX_COUNT * POLICY_CHECK_INTERVAL) * 100;

  return {
    progress,
  };
};

export default useCheckPolicyProgress;